import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { COLLECTIONS, USER_ACTIONS } from 'src/constants';
import { queryKeys, requestCCApi } from 'src/utils';

import { narrativeGenerators } from '../userActions/helper';

export const useDeleteBulkReplaceRequest = () => {
  return useMutation({
    mutationFn: deleteBulkReplaceRequest,
    onSuccess: () => {
      queryClient.invalidateQueries(
        queryKeys.bulkReplaceRequests.invalidateAll(),
      );
      queryClient.invalidateQueries(
        queryKeys.bulkReplaceRequestNamesByAssemblyIds.invalidateAll(),
      );
      queryClient.invalidateQueries(queryKeys.assemblies.invalidateAll());
      queryClient.invalidateQueries(queryKeys.assemblyListing.invalidateAll());
    },
  });
};

const deleteBulkReplaceRequest = async (bulkReplaceData: any) => {
  const response = await requestCCApi({
    url: `/bulkReplaceRequests/${bulkReplaceData?.id}?${new URLSearchParams({
      narrative: (
        narrativeGenerators[COLLECTIONS.BULK_REPLACEMENT][
          USER_ACTIONS.DELETE
        ] as (replacementName: string) => string
      )(bulkReplaceData?.replaceName),
    })}`,
    method: 'DELETE',
  });

  return response;
};
